import React from 'react';
import Divider from '@common/components/Divider/Divider';
import { Button, ButtonTypes } from '@common/components';
import * as Styled from './styles';

interface ISubmissionFlowFooter {
  backText?: string;
  cancelText?: string;
  continueText?: string;
  continueDisabled?: boolean;
  errorText?: string;
  onBack?: () => void;
  onContinue?: () => void;
  onCancel?: () => void;
  customLeftContent?: React.ReactNode;
  customRightContent?: React.ReactNode;
}

const SubmissionFlowFooter = ({
  backText = 'Back',
  cancelText = 'Cancel',
  continueText = 'Continue',
  continueDisabled = false,
  errorText,
  onBack,
  onCancel,
  onContinue,
  customLeftContent,
  customRightContent,
}: ISubmissionFlowFooter) => {

  const handleBack = () => {
    onBack!();
  };

  const handleCancel = () => {
    onCancel!();
  };

  const prepareLeftButtons = () => {
    let buttons = [];

    if (onBack) {
      buttons.push(<Button key="cancel-button" onClick={handleBack} text={backText} type={ButtonTypes.TEXT} />);
    }
    return buttons;
  };

  const prepareRightButtons = () => {
    let buttons = [];

    if (onCancel) {
      buttons.push(<Button key="cancel-button" onClick={handleCancel} text={cancelText} type={ButtonTypes.TEXT} />);
    }

    if (customRightContent) {
      buttons.push(<React.Fragment key="custom-right-content">{customRightContent}</React.Fragment>);
    }

    if (onContinue) {
      buttons.push(
        <Button
          key="continue-button"
          data-testid="saveButton"
          onClick={onContinue}
          text={continueText}
          type={ButtonTypes.SUCCESS}
          minWidth={160}
          disabled={continueDisabled}
        />,
      );
    }

    if (buttons.length > 1) {
      const withDividers: React.ReactNode[] = [];
      buttons.forEach((button, index) => {
        withDividers.push(button);
        if (index < buttons.length - 1) {
          withDividers.push(<Divider key={`divider-${index}`} type="vertical" size="50px" thickness={1} />);
        }
      });
      return withDividers;
    }

    return buttons;
  };

  return (
    <Styled.SubmissionFlowFooterWrap>
      <Styled.SubmissionFlowFooterInner>
        <Styled.Left>{customLeftContent || prepareLeftButtons()}</Styled.Left>
        <Styled.Right>
          {errorText && <Styled.ErrorText>{errorText}</Styled.ErrorText>}
          {prepareRightButtons()}
        </Styled.Right>
      </Styled.SubmissionFlowFooterInner>
    </Styled.SubmissionFlowFooterWrap>
  );
};

export default SubmissionFlowFooter;
